import { hydrating, reset, set_hydrate_node, set_hydrating } from '../hydration.js';
import { create_comment, create_element } from '../operations.js';
import { create_trusted_html } from '../reconciler.js';
import { attach } from './attachments.js';

/*                         */
let supported = null;

/**
 *
 *
 *
 *
 */
function is_supported() {
	if (supported === null) {
		var select = create_element('select');
		select.innerHTML = create_trusted_html('<option><span>t</span></option>');
		supported = /*                  */ (select.firstChild)?.firstChild?.nodeType === 1;
	}

	return supported;
}

/**
 *
 *
 *
 */
export function selectedcontent(element, update_element) {
	/*                                              */
	if (!is_supported()) return;

	/*                                                                                           */
	attach(element, () => () => {
		const select = element.closest('select');
		if (!select) return;

		const observer = new MutationObserver((entries) => {
			var selected = false;

			for (const entry of entries) {
				if (entry.target === element) {
					/*                                                             */
					return;
				}

				/*                                                                                  */
				selected ||= !!entry.target.parentElement?.closest('option')?.selected;
			}

			if (selected) {
				/*                                           */
				element.replaceWith((element = /*                      */ (element.cloneNode(true))));
				update_element(element);
			}
		});

		observer.observe(select, {
			childList: true,
			characterData: true,
			subtree: true
		});

		return () => {
			observer.disconnect();
		};
	});
}

/**
 *
 *
 *
 *
 *
 */
export function customizable_select(element, rich_fn) {
	var was_hydrating = hydrating;

	if (!is_supported()) {
		set_hydrating(false);
		element.textContent = '';
		element.append(create_comment(''));
	}

	try {
		rich_fn();
	} finally {
		if (was_hydrating) {
			if (hydrating) {
				reset(element);
			} else {
				set_hydrating(true);
				set_hydrate_node(element);
			}
		}
	}
}
